function editComment() {
    const nodes = [...this.selectedNodes]

    if (1 === nodes.length) {
        this.startEditNodeComment(nodes[0])
    }
}

export default {
    //'Ctrl+Alt+C': editComment,
}
